import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../lib/supabaseClient';
import './Header.css';
import ShinyText from './ShinyText';
import CreditsCounter from './CreditsCounter';
import AppIcon from './icons/AppIcon';

const Header = ({ onSettingsClick }) => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const [companyName, setCompanyName] = useState('');

  const toggleMenu = () => {
    console.log('🍔 Menu hamburguer clicado! Estado atual:', isMenuOpen);
    setIsMenuOpen(!isMenuOpen);
    console.log('🍔 Novo estado:', !isMenuOpen);
  };

  const handleSettingsClick = () => {
    onSettingsClick();
    setIsMenuOpen(false); // Fecha o menu após clicar
    navigate('/configuracoes');
  };

  const handleLogout = () => {
    logout();
    // Redireciona para a página de login e recarrega a aplicação
    navigate('/login');
    setIsMenuOpen(false);
    // Força recarregamento para garantir que o contexto seja reinicializado
    window.location.reload();
  };

  // Carrega o nome da empresa do usuário logado
  useEffect(() => {
    let cancelled = false;
    const loadCompany = async () => {
      try {
        if (!user?.id) return;
        // 1) Buscar company_id no profile
        const { data: prof, error: e1 } = await supabase
          .from('profiles')
          .select('company_id')
          .eq('id', user.id)
          .maybeSingle();
        if (e1 || !prof?.company_id) return;
        const companyId = prof.company_id;
        // 2) Buscar nome_fantasia na empresa
        const { data: emp, error: e2 } = await supabase
          .from('configuracoes_empresa')
          .select('nome_fantasia')
          .eq('company_id', companyId)
          .maybeSingle();
        if (!cancelled && !e2) {
          const nome = emp?.nome_fantasia || '';
          setCompanyName(nome);
        }
      } catch (_) {}
    };
    loadCompany();
    return () => { cancelled = true; };
  }, [user?.id]);

  // Fecha o menu ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest('.menu-wrapper')) {
        console.log('🍔 Clicou fora do menu, fechando...');
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <header className="header-container">
      {/* Texto de boas-vindas à esquerda */}
      <div className="header-left" title={companyName ? `Bem-Vindo a ${companyName}` : 'Bem-Vindo'}>
        <ShinyText
          text={`Bem-Vindo${companyName ? ` a ${companyName}` : ''}`}
          disabled={!companyName}
          speed={5}
          className="header-welcome"
        />
      </div>

      {/* Contador de créditos e Menu hamburguer */}
      <div className="header-right">
        <CreditsCounter />
        
        <div className="menu-wrapper">
          <button 
            className="menu-button" 
            onClick={toggleMenu}
            aria-label="Menu"
          >
            <AppIcon name="menu" />
          </button>

          {isMenuOpen && (
            <div className="menu-dropdown">
              <div className="menu-item" onClick={handleSettingsClick}>
                <AppIcon name="settings" />
                <span>Configurações</span>
              </div>
              <div className="menu-item" onClick={handleLogout}>
                <AppIcon name="logout" />
                <span>Sair</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
